import Vue from "vue";
import Vuex from "vuex";
import VueSocketIO from "vue-socket.io";
import websocket from "./websocket";
import local from "@/utils/local.js";
import moment from "moment";
import { api_routerjurisdiction, userAuth } from "@/api/acc.js";
import { patientSavePage } from "@/api/addCourseOfDisease";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isCollapse: false, //左侧菜单栏开关
    setPassWordDialog: 0, //修改密码弹窗
    chatUserList: [], //聊天用户列表
    userinfo: {}, //入案管理处理 人员信息
    patientFilesList: [], //对照录入列表数据
    patientId: "", //进入会话取到患者ID
    wholeCourseId: "", //进入会话传来的全病程ID
    inquiryId: "", //进小房间传来的问诊ID
    inquiryStatus: "", //进入小房间传来的问诊状态
    messageType: "", //进入小房间传来的问诊类型
    roomId: "", //进入小房间传来的问诊房间号
    conversationID: "",
    minconversationID: "",
    currentMessageList: [], // 当前消息列表
    schemeId: "", //方案ID
    patientInfo: {}, // 入案管理左侧选择的患者
    groupCode: "", // 房间对话id
    fromId: "", // 推送人id
    token: "",
    menuData: [], //菜单列表
    authList: [],
    companyId: local.get("companyId"), //平台ID
    hospitalId: local.get("hospitalId"), //线下机构id
    platformId: local.get("platformId"), //互医机构id
    imageUrl: local.get("imageUrl"),
    indexUrl: local.get("indexUrl"),
    orgName: local.get("orgName"), //机构名称
    userPlatForm: local.get("userPlatForm"), //平台：platForm 机构：organization
    serviceItem: {}, //疗程管理选中的服务
    chapterId: null, //关联推送培训教程所需要的参数  lxg
    refId: null, //请求关联推送弹窗的培训教程的id
    refType: null, //  1 问卷  3 宣教  4 培训教程
    chapterArr: [], //关联推送回显id
    toolListQuery: {}, //宣教搜索条件
    toolSaveSearch: false, //是否保存宣教搜索条件
    courseId: null, //关联推送回显id
    patientSubmitSymptom: [],
    patientObj: {}, //疗管列表 患者搜索
    diseaseTypeId: null, //编链里面的病种id
    rightTypeParams: {}, //疗管右侧tab 传入socket :setRightParams 事件参数
    toolsList: [
      {
        status: false,
        recordTypeName: "PICC置管",
        recordTypeId: "10",
      },
      {
        status: false,
        recordTypeName: "体温",
        recordTypeId: "6",
      },
      {
        status: false,
        recordTypeName: "血压",
        recordTypeId: "2",
      },
      {
        status: false,
        recordTypeName: "血糖",
        recordTypeId: "1",
      },
      {
        status: false,
        recordTypeName: "饮水",
        recordTypeId: "7",
      },
      {
        status: false,
        recordTypeName: "体重",
        recordTypeId: "8",
      },
      {
        status: false,
        recordTypeName: "呼吸",
        recordTypeId: "4",
      },
      {
        status: false,
        recordTypeName: "心率",
        recordTypeId: "3",
      },
      {
        status: false,
        recordTypeName: "血氧",
        recordTypeId: "5",
      },
      {
        status: false,
        recordTypeName: "用药",
        recordTypeId: "9",
      },
      {
        status: false,
        recordTypeName: "试管编号",
        recordTypeId: "12",
      },
    ],
    allEntryFormData: {},
  },
  mutations: {
    //宣教搜索条件暂存
    TOOL_SEARCH_CONDITION(state, data) {
      state.toolListQuery = data.toolListQuery;
      state.toolSaveSearch = data.isChange;
    },
    // token 登录成功后执行
    GET_TOKEN(state, info) {
      state.token = info;
      let vueSocketIO = new VueSocketIO({
        debug: false,
        connection: `${process.env.VUE_APP_API_WS_URL}?token=${info}`,
        vuex: {
          store: websocket,
          mutationPrefix: "SOCKET_",
          actionPrefix: "SOCKET_",
        },
      });
      Vue.use(vueSocketIO);
    },
    //方案ID
    SCHEME_ID(state, info) {
      state.schemeId = info;
    },
    //聊天用户列表
    CHAT_USER_LIST(state, paload) {
      state.chatUserList = paload;
    },
    // 全局修改密码弹窗 zeb
    setPassWordDialogChange(state, paload) {
      state.setPassWordDialog = paload;
    },
    //左侧菜单栏 zeb
    updataIsCollapse(state, paload) {
      state.isCollapse = paload;
    },
    SET_USER_INFO(state, userinfo) {
      state.userinfo = userinfo;
    },
    //进入会话传来的患者ID
    PATIENT_ID(state, info) {
      state.patientId = info;
    },
    //进入会话传来的全病程ID
    WHOLE_COURSE_ID(state, info) {
      state.wholeCourseId = info;
    },
    //进小房间传来的问诊ID
    INQUIRY_ID(state, info) {
      state.inquiryId = info;
    },
    //进入小房间传来的问诊状态
    INQUIRY_STATUS(state, info) {
      state.inquiryStatus = info;
    },
    //进入小房间传来的问诊类型
    MESSAGE_TYPE(state, info) {
      state.messageType = info;
    },
    //进入小房间传来的二级房间号
    ROOM_ID(state, info) {
      state.roomId = info;
    },
    upDateRoomId(state, info) {
      state.conversationID = info;
    },
    minupDateRoomId(state, info) {
      state.minconversationID = info;
    },
    // 入案管理左侧选择的患者
    patientInfo(state, info) {
      state.patientInfo = info;
      sessionStorage.setItem("patientInfo", JSON.stringify(info));
    },
    // 疗程管理选中的服务
    serviceItem(state, info) {
      state.serviceItem = info;
    },
    // groupCode存储
    GROUP_CODE(state, info) {
      state.groupCode = info;
    },
    FROM_ID(state, info) {
      state.fromId = info;
    },
    SET_PLATFORM(state, info) {
      state.userPlatForm = info;
      local.set("userPlatForm", info);
    },
    SET_PLATFORMINFO(state, info) {
      state.companyId = info.companyId;
      state.hospitalId = info.hospitalId;
      state.platformId = info.platformId;
      state.orgName = info.orgName;
      state.imageUrl = info.imageUrl;
      state.indexUrl = info.indexUrl;
      local.set("companyId", info.companyId);
      local.set("hospitalId", info.hospitalId);
      local.set("platformId", info.platformId);
      local.set("orgName", info.orgName);
      local.set("imageUrl", info.imageUrl);
      local.set("indexUrl", info.indexUrl);
    },
    CHANGE_MENU(state, list) {
      state.menuData = list;
    },
    CHANGE_AUTH(state, list) {
      state.authList = list;
    },
    chapter_ID(state, id) {
      state.chapterId = id;
    },
    ref_ID(state, id) {
      state.refId = id;
    },
    ref_TYPE(state, type) {
      state.refType = type;
    },
    chapter_ARR(state, arr) {
      state.chapterArr = arr;
    },
    course_Id(state, id) {
      state.courseId = id;
    },
    SUBMIT_SYMPTOM_DATA(state, list) {
      state.patientSubmitSymptom = list;
    },
    SEARCH_PATIENT(state, name) {
      state.patientObj = name;
    },
    SEARCH_PARAMS(state, obj) {
      state.rightTypeParams = obj;
    },
    DiseaseTypeId(state, diseaseTypeId) {
      state.diseaseTypeId = diseaseTypeId;
    },
    All_Entry_FormData(state, info) {
      state.allEntryFormData = info;
    },
  },
  actions: {
    async getPatientSavePage(context) {
      let res = await patientSavePage({
        startTime: moment()
          .subtract(3, "months")
          .format("YYYY-MM-DD"),
        endTime: moment().format("YYYY-MM-DD"),
        current: 1,
        size: 10,
        patientId: JSON.parse(sessionStorage.getItem("patientInfo")).patientId,
      });
      if (res.code == 0) {
        context.commit("SUBMIT_SYMPTOM_DATA", res.data.records);
      }
    },
    getMenuList(context) {
      api_routerjurisdiction().then((res) => {
        if (res.code == 0) {
          context.commit("CHANGE_MENU", res.data);
        }
      });
    },
    getUserAuthList(context, obj) {
      let params = {
        keyword: obj.key,
      };
      userAuth(params).then((res) => {
        if (res.code == 0) {
          let end = res.data;
          end.map((item) => {
            if (item.isChecked) {
              item.searchFlag = obj.search;
            }
          });
          context.commit("CHANGE_AUTH", end);
        }
      });
    },
    GET_TOKEN({ commit }, data) {
      commit("GET_TOKEN", data);
    },
  },
  modules: {},
});
